import { render, staticRenderFns } from "./LawMatterStatusForm.vue?vue&type=template&id=4e909a00&"
import script from "./LawMatterStatusForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterStatusForm.vue?vue&type=style&index=0&id=4e909a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports